<template>
  <div class="admin">
    <div
      v-if="!addAdmin"
      class="begin"
    >
      <div class="header">
        <div class="flex items-center justify-between">
          <div class="titles">
            <div class="title text-black font-semibold text-lg">
              {{ $t('adminMenu').substr(-20, 15) }}
            </div>
          </div>
          <div class="flex-one current-month ">
            <div class="search-bloc flex items-center justify-between">
              <div class="recherche-name">
                <div class="relative recherche justify-center items-center pl-8 pr-4 py-4 bg-white shadow rounded">
                  <div class="icon-search absolute inset-y-0 left-0 flex items-center px-4">
                    <svg-icon
                      name="ic_search"
                      original
                      class="icon w-4 h-4"
                    />
                  </div>
                  <div class="search-input ml-4">
                    <label>
                      <input
                        v-model="search"
                        type="text"
                        :placeholder="$t('searchName')"
                        class="recherche-input"
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="select-pays ml-4">
                <button-base
                  :label="$t('addMemberButton')"
                  @click.native="showAddAdmin"
                />
              </div>
            </div>
          </div>
        </div><br>
      </div>
      <div class="flex items-center gap-4 mt-4">
        <div
          class="p-4 cursor-pointer inline-block rounded font-semibold"
          :class="viewMode === 'active' ? 'bg-gray-200 text-black' : 'text-gray-600 hover:text-black'"
          @click="switchView('active')"
        >
          Administrateurs actifs
        </div>
        <div
          class="p-4 cursor-pointer inline-block rounded font-semibold"
          :class="viewMode === 'inactive' ? 'bg-red-100 text-red-700' : 'text-gray-600 hover:text-red-500'"
          @click="switchView('inactive')"
        >
          Administrateurs archivés
        </div>
      </div>
      <div class="body mt-4">
        <div class="user-list bg-white rounded font-semibold shadow p-6 flex items-center">
          <div class="flex-one item-color w-2/5">{{ $t('completeName') }}</div>
          <div class="flex-one item-color w-1/5">{{ $t('phone') }}</div>
          <div class="flex-one item-color w-2/5">{{ $t('email') }}</div>
          <div class="flex-one item-color w-2/12 uppercase">{{ $t('AccessRights') }}</div>
          <div class="flex-one item-color w-1/12 uppercase">{{ $t('actions') }}</div>
        </div>
        <div class="loading" :class="{ 'not_empty': isLoading === false }">
          <loading
            :active="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
            loader="dots"
            color="#0B5382"
            background-color="transparent"
          />
        </div>

        <div v-if="nothing && !isLoading" class="no-student text-center text-lg py-32">
          {{ $t('noAdminAdded') }}
        </div>
        <div v-if="!isLoading" class="list-user">
          <admin-list
            v-for="(item, i) in sortedArrayUser"
            :key="i"
            :user-list="item"
            :view-mode="viewMode"
            @adminDeleted="loadAllAdmin"
            @adminUnarchived="loadAllAdmin"
          />

          <pagination-base
            :currentPage="currentPage"
            :totalPages="totalPages"
            :visiblePages="visiblePages"
            @page-change="handlePageChange"
          />
        </div><br>
      </div>
    </div>
    <add-admin
      v-if="addAdmin"
      @clickToGoBack="clickToGoBack"
    />
  </div>
</template>

<script>
import ButtonBase from '../../components/helper/add/button-base'
import AddAdmin from '../../components/helper/admin/add-admin'
import http from '@/plugins/http'
import apiRoute from '@/router/api-routes'
import AdminList from '@/components/helper/admin/admin-list'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import PaginationBase from '@/components/helper/add/pagination-base.vue'
export default {
  name: 'index',
  components: { PaginationBase, AdminList, AddAdmin, ButtonBase, Loading },
  props: {
    isSearch: String
  },
  data () {
    return {
      search: '',
      addAdmin: false,
      isLoading: true,
      fullPage: false,
      nothing: false,
      allAdmin: [],
      currentPage: 1,
      limit: 10,
      viewMode: 'active'
    }
  },
  created () {
    this.loadAllAdmin()
  },
  computed: {
    filteredAdmin () {
      const norm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      if (!this.search || this.search.trim() === '') return this.allAdmin
      const words = norm(this.search).trim().split(/\s+/).filter(w => w.length > 0)
      return this.allAdmin.filter(item => {
        const haystack = [item.firstName, item.lastName, item.phone, item.email].map(norm).join(' ')
        return words.every(w => haystack.includes(w))
      })
    },
    sortedArrayUser () {
      const start = (this.currentPage - 1) * this.limit
      return this.filteredAdmin.slice(start, start + this.limit)
    },
    totalPages () {
      return Math.max(1, Math.ceil(this.filteredAdmin.length / this.limit))
    },
    visiblePages () {
      return Math.min(5, this.totalPages)
    }
  },
  watch: {
    search () { this.currentPage = 1 }
  },
  methods: {
    handlePageChange (newPage) {
      this.currentPage = newPage
    },
    switchView (mode) {
      if (this.viewMode === mode) return
      this.viewMode = mode
      this.currentPage = 1
      this.loadAllAdmin()
    },
    loadAllAdmin () {
      this.isLoading = true
      http.post(apiRoute.baseURL + apiRoute.getAdmin, {
        page: 1,
        limit: 10000,
        status: this.viewMode === 'inactive' ? 'INACTIVE' : 'ACTIVE'
      }, {
        headers: {
          Authorization: `Bearer ${this.$store.getters.loginToken}`
        }
      }).then(response => {
        this.allAdmin = response.rows || []
        this.nothing = this.allAdmin.length === 0
        this.isLoading = false
      }).catch(error => {
        console.log(error)
        this.isLoading = false
      })
    },
    clickToGoBack () { // CLOSE ADD NEW ADMIN
      this.addAdmin = false
      this.loadAllAdmin()
    },
    showAddAdmin () { // OPEN ADD ADMIN
      this.addAdmin = true
    },
    onCancel () {
      console.log('User cancelled the loader.')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/assets/style/sass/variables";
  .admin {
    padding: 2rem 4rem 4rem 1.5rem;
  }
  .user-list {
    color: $light_gray;
  }
  .loading {
    position: relative;
    height: 10vh;
  }
  .not_empty {
    height: auto;
  }
</style>
